import Grid from '../Grid'
import classes from './GridContainer.module.scss';
import { motion } from 'framer-motion'
import { Card } from '../Card';
import { useSelector } from 'react-redux';
import { useGameSounds } from '@educaplay/core';
import { RELACIONAR_SOUNDS } from '../../utils/constants';

const GridContainer = (props) => {
    const { onAnswer, draw, setDraw } = props;
    const cardsToShow = useSelector(state => state.game.questions[state.game.currentIndex].grid);
    const hasLiveActived = useSelector(state => state.game.liveActived);
    const gameSound = useGameSounds();

    const handleAnswer = ({ answer, isCorrect, playErrorSound }) => {
        onAnswer(answer, {
            showFeedback: hasLiveActived,
            playErrorSound: playErrorSound ?? true
        });
        if(isCorrect) {
            gameSound.play(RELACIONAR_SOUNDS.DESELECT_GROUP);
        }
        setDraw(!isCorrect);
    }

    return (
        <motion.div className={classes.game} layout transition={{ duration: 1.5 }}>
            {draw && <Grid cards={cardsToShow} onAnswer={handleAnswer} />}
            <div className={classes.deck}>
                {!draw && (<>
                    {cardsToShow.map((card) => {
                        return (
                            <motion.div key={card.id} className={classes.cardWrapper} layoutId={card.id} transition={{ type: "spring", bounce: 0.1 }} >
                                <Card cardData={card} text={card.ENUNCIADO} />
                            </motion.div>
                        )
                    })}
                </>)}
            </div>
        </motion.div>
    )
}

export default GridContainer;